 <template>

  <div class="row wrapper border-bottom white-bg page-heading">
		<div class="col-6 col-md-8">
			<h2 class="mt-1">{{$t('navigations.dashboard')}}</h2>
		</div>
		
			
	
	</div>
  <div class="wrapper wrapper-content">
    <div class="row">
      <div class="col-lg-6 pr-0 pl-1 mb-1">
        <div class="ibox-body">
          <div class="ibox-title style_2 d-flex justify-content-between py-1">
            <h5 class="mt-2">{{$t('navigations.site summary')}}</h5>
              <div class="graphbtncontainer">
                <div class="graphbutton">
                  <img
                    src="../../assets/images/bar_clr.png"
                    @click.prevent="fourthchartchange('bar')"
                  />
                </div>
                <div class="graphbutton">
                  <img
                    src="../../assets/images/horiz_bar_clr.png"
                    @click.prevent="fourthchartchange('barhorizondal')"
                  />
                </div>
                <div class="graphbutton">
                  <img
                    src="../../assets/images/Line_clr.png"
                    @click.prevent="fourthchartchange('line')"
                  />
                </div>
                <div class="graphbutton">
                  <img
                    src="../../assets/images/Pie_clr.png"
                    @click.prevent="fourthchartchange('pie')"
                  />
                </div>
                <div class="graphbutton">
                  <img
                    src="../../assets/images/bubble_clr.png"
                    @click.prevent="fourthchartchange('scatter')"
                  />
                </div>
              </div>
          </div>
          <div class="ibox-content">
            <div v-if="summaryLoading" class="chart-loader">
    <div class="spinner-border" role="status" aria-label="Loading"></div>
    <div class="loader-text">Loading...</div>
  </div>
  <div v-show="!summaryLoading">
            <apexchart
              v-if="
                summarychart.charttype != 'pie' &&
                  summarychart.charttype != 'barhorizondal'
              "
              width="100%"
              height="250px"
              :key="summaryChartKey"
              :type="summarychart.charttype"
              :options="summarychart.chartOptions"
              :series="summarychart.dataseries"
            ></apexchart>
            <apexchart
              v-if="summarychart.charttype == 'barhorizondal'"
              width="100%"
              height="250px"
              type="bar"
              :key="summaryChartKey"
              :options="summarybarchart.chartOptions"
              :series="summarybarchart.dataseries"
            ></apexchart>
            <apexchart
              v-if="summarychart.charttype == 'pie'"
              width="100%"
              height="250px"
              :key="summaryChartKey"
              :type="summarychart.charttype"
              :options="summarychart.piechartOptions"
              :series="summarychart.piedataseries"
            ></apexchart>
            <!-- <canvas id="barChart" height="140"></canvas> -->
             </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 pr-0 pl-1 mb-1">
        <div class="ibox-body">
          <div class="ibox-title style_2 d-flex justify-content-between py-1">
            <h5 class="mt-2">{{$t('navigations.subject summary')}}</h5>
              <div class="graphbtncontainer">
                <div class="graphbutton">
                  <img
                    src="../../assets/images/bar_clr.png"
                    @click.prevent="thirdchartchange('bar')"
                  />
                </div>
                <div class="graphbutton">
                  <img
                    src="../../assets/images/horiz_bar_clr.png"
                    @click.prevent="thirdchartchange('barhorizondal')"
                  />
                </div>
                <div class="graphbutton">
                  <img
                    src="../../assets/images/Line_clr.png"
                    @click.prevent="thirdchartchange('line')"
                  />
                </div>
                <div class="graphbutton">
                  <img
                    src="../../assets/images/Pie_clr.png"
                    @click.prevent="thirdchartchange('pie')"
                  />
                </div>
                <div class="graphbutton">
                  <img
                    src="../../assets/images/bubble_clr.png"
                    @click.prevent="thirdchartchange('scatter')"
                  />
                </div>
              </div>
          </div>
          <div class="ibox-content" ref="patientWrap">
            <apexchart
              v-if="patientchart && patientchart.charttype !== 'pie' && patientchart.charttype !== 'barhorizondal'"
              width="100%"
              height="250px"
              :type="patientchart.charttype"
              :options="patientchart.chartOptions"
              :series="patientchart.dataseries"
            ></apexchart>
            <apexchart
              v-if="patientchart && patientchart.charttype == 'barhorizondal'"
              width="100%"
              height="250px"
              type="bar"
              :options="patientbarchart.chartOptions"
              :series="patientbarchart.dataseries"
            ></apexchart>
            <apexchart
              v-if="patientchart && patientchart.charttype == 'pie' && hasPatientPieData"
              width="100%"
              height="250px"
              :type="patientchart.charttype"
              :options="patientchart.piechartOptions"
              :series="patientchart.piedataseries"
            ></apexchart>
            <!-- <canvas id="barChart" height="140"></canvas> -->
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>
<script src="./CRA_summary.js"></script>
<style scoped>
@import "../../assets/style.css";
@import "../../assets/bootstrap.css";
@import "../../assets/font-awesome/css/font-awesome.css";
.widget {
  margin-top: 0rem;
  margin-bottom: 0rem;
}
.widgetmargin {
  margin-top: -13px !important;
}
.ibox-body {
  background-color: #ffffff;
  margin: 3rem, 0;
}

.style1 {
  background-color: black !important;
  color: #ffffff;
}
.btn-view {
  color: #fff !important;
  background-color: #bb458f !important;
  border-color: #bb458f !important;
}
.btn-view:hover {
  color: #fff;
  background-color: #666ccb;
  border-color: #666ccb;
}
.btn-view:active {
  color: rgb(255, 255, 255) !important;
  background-color: #dda2c7 !important;
  border-color: #dda2c7 !important;
}
.ibox-title {
  color: inherit;
  margin-bottom: 0;
  padding: 1rem;
  position: relative;
  clear: both;
  right: 0;
  margin-right: 0px;
  width: unset !important;
  margin-left: 0px !important;
  margin-top: 0px !important;
}
.padding_bottom {
  padding-bottom: 2rem;
}
.ibox-title h5 {
  height: 0rem;
  padding: 0rem;
}
.ibox-title h5:hover {
  background-color: inherit;
  padding: 0;
  cursor: not-allowed;
}
.titlemsg {
  font-size: 15px;
  font-weight: bold;
  color: var(--primary-color);
}
.switchbtn {
  background-color: #bb458f !important;
  height: max-content;
  border-color: #bb458f !important;
  color: white !important;
  float: right;
}
.switchbtn:active {
  height: max-content;
  border-color: #bb458f !important;
  color: white !important;
  float: right;
  background-color: #bb458f;
}
.switchbtn:hover {
  height: max-content;
  border-color: #bb458f !important;
  color: white !important;
  float: right;
  background-color: #bb458f;
}
.queryhover:hover {
  color: #3c4192 !important;
  -webkit-transition: color ease-in 400ms;
  transition: color ease-in 400ms;
  cursor: pointer;
}

.widgetminheight {
  min-height: 102px;
}
.graphbutton {
  width: fit-content;
  padding: 3px;
}
.graphbutton:hover {
  cursor: pointer;
  border-color: #3c4192;
}
.graphbtncontainer {
  display: flex;
  gap: 5px;
}
img {
  margin-left: 0px !important;
}
.fixed-height {
  min-height: 200px;
  overflow-y: scroll;
  margin-bottom: 30px;
  max-height: 400px;
}
thead tr th {
  background: white;
  position: sticky;
  top: 0;
  z-index: 10;
}
.selectdefault {
  left: 0;
}
.selectdefaultcontainer {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
}
.btn:focus {
  outline: none;
  box-shadow: none;
}
.fontprop {
  font-size: 10px !important;
}
.btn-setdefault {
  position: relative;
  padding:0.2rem 0.4rem;
  text-align: center;
  font-size:0.7rem;
  background-color: #ec4758;
  color: white !important;
  border-radius:3px;
}
.ibox-title h5{
    float:none;
}
.width-10{
  width:50%;
}
.form-select{
  border-radius:0!important;
}
.form-select:focus{
  border-color:#145faf!important;
  box-shadow: 0 0 0!important;
}
</style>
